"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionTypes = void 0;
var FunctionTypes;
(function (FunctionTypes) {
    let OnboardPaymentAccount;
    (function (OnboardPaymentAccount) {
        OnboardPaymentAccount.returnPath = "withdraw-balance/success";
        OnboardPaymentAccount.refreshPath = "withdraw-balance/refresh";
    })(OnboardPaymentAccount = FunctionTypes.OnboardPaymentAccount || (FunctionTypes.OnboardPaymentAccount = {}));
})(FunctionTypes = exports.FunctionTypes || (exports.FunctionTypes = {}));
//# sourceMappingURL=onboardPaymentAccount.types.js.map